import { RedoClient } from "@redotech/redo-api-client";
import { AxiosInstance } from "axios";

export class BigcommerceServerApiClient {
  private readonly redoClient: RedoClient;

  constructor(baseURL: string = "https://bigcommerce-server.getredo.com") {
    this.redoClient = new RedoClient(baseURL);
  }

  get client(): AxiosInstance {
    return this.redoClient.client;
  }

  async attachCustomFeeToCart({
    widgetId,
    checkoutId,
    productType,
    feeAmount,
  }: {
    widgetId: string;
    checkoutId: string;
    productType: string;
    feeAmount: number;
  }) {
    const response = await this.client.post(
      `widgets/${widgetId}/checkouts/${checkoutId}/custom-fee`,
      { productType, feeAmount },
    );
    return response.data;
  }

  async deleteCustomFeeFromCart({
    widgetId,
    checkoutId,
  }: {
    widgetId: string;
    checkoutId: string;
  }) {
    const response = await this.client.delete(
      `widgets/${widgetId}/checkouts/${checkoutId}/custom-fee`,
    );
    return response.data;
  }
}
